import { ArrowRight } from "lucide-react";
import { PHOTOS } from "@/data/destinations";
import { useLang } from "@/i18n/LanguageContext";
import { scrollToId } from "@/App";
import Reveal from "@/components/Reveal";

export default function AlphaGuide() {
  const { t } = useLang();
  const bullets = ["b1", "b2", "b3"];

  return (
    <section id="alpha-guide" className="relative py-28 lg:py-40" data-testid="alpha-guide-section">
      <div className="mx-auto grid max-w-[1500px] items-center gap-16 px-6 lg:grid-cols-2 lg:gap-24 lg:px-12">
        <Reveal className="relative">
          <div className="clipped-frame relative overflow-hidden">
            <img src={PHOTOS.concierge} alt="Alpha Guide" loading="lazy" className="img-spotlight aspect-[4/5] w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050814]/70 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-4 border border-[#d4af37]/40 bg-[#0a1128]/95 px-6 py-4 backdrop-blur-md lg:-right-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#d4af37]">Alpha Guide</div>
            <div className="mt-1 font-serif text-xl font-light text-white">24/7 · 39+ {t("hero.statCities")}</div>
          </div>
          <div className="pointer-events-none absolute -left-4 -top-4 h-24 w-24 border-l border-t border-[#d4af37]/50" />
        </Reveal>

        <div>
          <Reveal>
            <p className="eyebrow mb-6">{t("guide.eyebrow")}</p>
            <h2 className="font-serif text-4xl font-light leading-tight text-white sm:text-5xl lg:text-6xl">
              {t("guide.title")}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-white/65">{t("guide.p1")}</p>
            <p className="mt-4 max-w-lg text-base font-light leading-relaxed text-white/65">{t("guide.p2")}</p>
          </Reveal>

          <div className="mt-10 space-y-6">
            {bullets.map((b, i) => (
              <Reveal key={b} delay={0.15 + i * 0.08}>
                <div className="flex gap-6 border-t border-white/10 pt-6" data-testid={`alpha-point-${i + 1}`}>
                  <span className="font-mono text-sm text-[#d4af37]">0{i + 1}</span>
                  <div>
                    <h3 className="font-serif text-xl font-light text-white">{t(`guide.${b}.t`)}</h3>
                    <p className="mt-1 text-sm font-light text-white/55">{t(`guide.${b}.d`)}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.4}>
            <button
              data-testid="alpha-cta"
              onClick={() => scrollToId("concierge")}
              className="btn-outline-gold group mt-10 flex items-center gap-3 px-8 py-4 text-sm font-medium tracking-wide"
            >
              {t("guide.cta")}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
